<template>
  <div class="bg-white rounded-lg m-3">
    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <!-- {{ data }} -->
    <transition name="fade">
      <div
        v-if="edit_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ edit_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">{{ title }}</p>
      <button
        v-if="
          (title.trim() === 'General Work Information' ||
            title.trim() === 'Termination Information') &&
          getUserRole.toLowerCase() === 'hrmanager'
        "
        class="text-white bg-primary flex justify-center items-center rounded-md cursor-pointer"
        @click="() => handleClick(title)"
      >
        <img
          class="object-contain p-1.5 w-7"
          src="@/assets/icons/pencil.png"
        />Edit
      </button>
      <button
        v-if="
          (title.trim() === 'Personal Information' ||
            title.trim() === 'Home and Contact Information' ||
            title.trim() === 'Emergency Contact') &&
          getUser.Id === getCurrentEmployeeId
        "
        class="text-white bg-primary flex justify-center items-center rounded-md cursor-pointer"
        @click="() => handleClick(title)"
      >
        <img
          class="object-contain p-1.5 w-7"
          src="@/assets/icons/pencil.png"
        />Edit
      </button>

      <button
        v-if="
          title.trim() === 'Employee Departments' &&
          getUserRole.toLowerCase() === 'hrmanager'
        "
        class="text-white bg-primary flex justify-center items-center rounded-md cursor-pointer gap-1 p-0.5"
        @click="() => handleAddDepartment(title)"
      >
        <svg
          id="Layer_1"
          viewBox="0 0 24 24"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          fill="#fff"
        >
          <path
            d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
          />
        </svg>
        Add
      </button>
    </div>
    <div
      class="justify-start px-3 py-5 gap-y-4 w-full text-sm"
      :class="[
        '',
        {
          'grid lg:grid-cols-2 w-3/4':
            title.trim() !== 'Employee Departments' &&
            title.trim() !== 'Employee Contracts',
        },
      ]"
    >
      <!-- {{ data }} -->
      <div v-for="(item, index) in data" :key="index">
        <div
          class="flex"
          v-if="
            title.trim() === 'Employee Departments' &&
            title.trim() !== 'Employee Contracts'
          "
        >
          <!-- <template> -->

          <div class="h-auto w-full">
            <div class="bg-white rounded-b-md">
              <div
                class="border-b-0.5 flex justify-between items-center pl-0 ml-0"
              >
                <div class="flex justify-between items-left my-1">
                  <!-- search -->
                  <input
                    v-model="searchInput"
                    type="search"
                    placeholder="Start typing to search..."
                    class="bg-gray-200 w-52 py-1 rounded-md"
                  />
                  <!-- search -->
                </div>
              </div>

              <div class="pb-2">
                <transition name="fade">
                  <div
                    v-if="edit_success"
                    class="p-1 text-center text-sm w-full bg-green-200"
                  >
                    {{ edit_success }}
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="loading"
                    class="inset-0 absolute z-50 bg-white w-full"
                  >
                    <loader class="center-h-v" />
                  </div>
                </transition>

                <transition name="fade">
                  <div
                    v-if="del_error"
                    class="p-1 text-center text-sm w-full bg-yellow-200"
                  >
                    {{ del_error }}
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="showLocCrSuccess"
                    class="p-1 text-center text-sm w-full bg-green-200"
                  >
                    {{ create_success }}
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="showLocDelSuccess"
                    class="p-1 text-center text-sm w-full bg-yellow-200"
                  >
                    {{ del_loca }}
                  </div>
                </transition>
                <div>
                  <ve-table
                    v-if="searchInput"
                    :columns="columns"
                    :table-data="filteredTableData"
                    sort-order="asc"
                  />

                  <ve-table
                    :columns="columns"
                    :tableData="currentTableData"
                    v-if="!searchInput.length"
                  >
                  </ve-table>

                  <p
                    v-if="searchInput.length && filteredTableData.length === 0"
                    class="text-center py-3"
                  >
                    No results
                  </p>

                  <p
                    v-if="
                      currentTableData.length == 0 && !loading && !get_error
                    "
                    class="p-1 text-center text-sm w-full bg-gray-100"
                  >
                    No Employee Departments found
                  </p>
                  <!-- Pagination -->
                  <div class="table-pagination text-center mt-2">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="totalCount"
                      :page-size="pageSize"
                      @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                  </div>
                  <!-- Pagination -->
                </div>
                <transition name="fade">
                  <div
                    v-if="get_error"
                    class="p-1 text-center text-sm w-full bg-yellow-200"
                  >
                    {{ get_error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <!-- </template> -->
        </div>

        <div
          class="flex"
          v-else-if="
            title.trim() !== 'Employee Departments' &&
            title.trim() === 'Employee Contracts'
          "
        >
          <!-- {{ item }} -->
          <div class="h-auto w-full">
            <div class="bg-white rounded-b-md">
              <div
                class="border-b-0.5 flex justify-between items-center pl-0 ml-0"
              >
                <div class="flex justify-between items-left my-1">
                  <input
                    v-model="searchInput"
                    type="search"
                    placeholder="Start typing to search..."
                    class="bg-gray-200 w-52 py-1 rounded-md"
                  />
                </div>
                <div class="hidden md:flex md:visible h-full gap-2 items-end">
                  <button
                    @click="showAddContract = true"
                    class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
                    style="
                      justify-items: center;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img class="h-5" src="@/assets/icons/add.svg" />
                    <i class="fi fi-sr-plus-small"></i>
                    Add
                  </button>
                  <button
                    @click="showBulkUpload = true"
                    class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
                    style="
                      justify-items: center;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img class="h-5" src="@/assets/icons/export-excel.png" />
                    Import
                  </button>
                  <button
                    @click="exportTemplate"
                    class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
                    style="
                      justify-items: center;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img class="h-5" src="@/assets/icons/export-excel.png" />
                    Export
                  </button>
                </div>
              </div>

              <div class="pb-2">
                <transition name="fade">
                  <div
                    v-if="edit_success"
                    class="p-1 text-center text-sm w-full bg-green-200"
                  >
                    {{ edit_success }}
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="loading"
                    class="inset-0 absolute z-50 bg-white w-full"
                  >
                    <loader class="center-h-v" />
                  </div>
                </transition>

                <transition name="fade">
                  <div
                    v-if="del_error"
                    class="p-1 text-center text-sm w-full bg-yellow-200"
                  >
                    {{ del_error }}
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="showLocCrSuccess"
                    class="p-1 text-center text-sm w-full bg-green-200"
                  >
                    {{ create_success }}
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    v-if="showLocDelSuccess"
                    class="p-1 text-center text-sm w-full bg-yellow-200"
                  >
                    {{ del_loca }}
                  </div>
                </transition>
                <div>
                  <ve-table
                    v-if="searchInput"
                    :columns="employeeContracts"
                    :table-data="empContracts"
                    sort-order="asc"
                  />

                  <ve-table
                    :columns="employeeContracts"
                    :tableData="empContracts"
                    v-if="!searchInput.length"
                  >
                  </ve-table>

                  <p
                    v-if="searchInput.length && filteredTableData.length === 0"
                    class="text-center py-3"
                  >
                    No results
                  </p>

                  <p
                    v-if="tableData.length == 0 && !loading && !get_error"
                    class="p-1 text-center text-sm w-full bg-gray-100"
                  >
                    No Employee Departments found
                  </p>

                  <div class="table-pagination text-center mt-2">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="totalCount"
                      :page-size="pageSize"
                      @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                  </div>
                </div>
                <transition name="fade">
                  <div
                    v-if="get_error"
                    class="p-1 text-center text-sm w-full bg-yellow-200"
                  >
                    {{ get_error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="flex whitespace-nowrap">
          <!-- {{ decryptDataLocal(item.value, decryptionKey) }} -->
          <p class="w-36 text-black">{{ item.name }}:</p>

          <div
            v-if="item.type !== 'date'"
            class="w-7/12 bg-gray-100 whitespace-nowrap text-gray-500 p-1 pr-2 rounded overflow-x-auto"
          >
            <!-- <p v-if="item.label == 'PayrollNumber'">
              {{ item.value }}
            </p> -->
            <p>
              {{
                item.label == 'EmployeeNo' || item.name == 'Type'
                  ? item.value
                  : decryptDataLocal(item.value, decryptionKey)
              }}
            </p>
          </div>
          <div
            v-else-if="item.type === 'date'"
            class="w-7/12 bg-gray-100 whitespace-nowrap text-gray-500 pr-2 p-1 rounded overflow-x-auto"
          >
            <p>
              {{
                item.value ? new Date(item.value).toLocaleDateString() : '...'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- delete -->
    <confirm-delete
      :callback="confirmDelete"
      :item="itemToDeleteName"
      :show-prompt="showDeletePrompt"
    >
    </confirm-delete>
    <edit-employee-department
      :showEditEmployeeDepartment="showEditEmployeeDepartment"
      :info="departmentToEdit"
      :reload="reloadLocal"
      :closeEditDepartment="handleClose"
    ></edit-employee-department>

    <!-- Create new employee -->
    <AddContract
      v-if="showAddContract"
      @close="showAddContract = false"
      :close="handleClose"
      :showAddContract="showAddContract"
      :reload="reload"
    ></AddContract>

    <EditEmployeeContract
      v-if="showEditContract"
      @close="showEditContract = false"
      :contractInfo="contractToEdit"
      :close="handleClose"
      :showEditContract="showEditContract"
      :reload="reload"
    ></EditEmployeeContract>
    <!-- Create multiple employees -->

    <!-- Create multiple employees -->
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="Employees"
      :url="url"
      :dateColumns="['DateOfJoining', 'StartDate', 'EndDate']"
      :columns="employeeBulkUploadColumns"
    ></BulkUpload>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';
import moment from 'moment';
import ConfirmDelete from '@/utils/confirmDelete.vue';
import EditEmployeeDepartment from './modals/editEmployeeDepartment.vue';

import { importTemplateGenerator } from '@/utils/importTemplateGenerator';
import decryptData from '@/utils/decrypt';
export default {
  components: {
    Loader,
    ConfirmDelete,
    EditEmployeeDepartment,
    AddContract: () =>
      import('@/components/employees/modals/addEmployeeContract.vue'),
    EditEmployeeContract: () =>
      import('@/components/employees/modals/editEmployeeContract.vue'),
    BulkUpload: () => import('@/utils/bulkUploadsUtils.vue'),
  },
  name: 'InformationCard',
  props: [
    'title',
    'data',
    'showEditEmployee',
    'editJobInformation',
    'addEmployeeDepartment',
    'index',
    'get_error',
    'edit_error',
    'edit_success',
    'empDepartmentsData',
    'empContracts',
    'item',
    'reload',
    'isLoading',
  ],

  data() {
    return {
      decryptionKey: '',
      decryptDataLocal: '',
      showAddContract: false,
      showBulkUpload: false,
      loading: false,
      tabTitle: null,
      info: {},
      message: null,
      searchInput: '',
      itemToDeleteName: '',
      itemToDelete: '',
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      del_error: null,
      showActions: false,
      departmentToDelete: null,
      contractTodDelete: null,
      showWarning: false,
      departmentToEdit: {},
      showDeletePrompt: false,
      showEditEmployeeDepartment: false,
      showEditContract: false,
      contractToEdit: null,

      // page index
      pageIndex: 1,
      // page size
      pageSize: 5,
      pageSizes: [],
      columns: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'center',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'Location',
          key: 'location',
          title: 'Company',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'Branch',
          key: 'branch',
          title: 'Branch',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'Department',
          key: 'Department',
          title: 'Department',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'JobTitle',
          key: 'JobTitle',
          title: 'JobTitle',
          headerAlign: 'left',
          align: 'left',
        },

        {
          title: 'Action',
          field: '',
          key: 'action',

          renderBodyCell: ({ row }) => {
            // function test() {
            //   console.log(row);
            // }
            return (
              <ve-popper
                trigger='clickToOpen'
                options={{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }}
              >
                {this.getUserRole.toLowerCase() === 'hrmanager' ? (
                  <div class='bg-white p-2 shadow-md popper'>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='boder-radius: 0 !important'
                      onClick={() => this.handleEditButtonClick(row)}
                    >
                      Edit
                    </button>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='boder-radius: 0 !important'
                      onClick={() => this.handleDeleteButtonClick(row)}
                    >
                      Delete
                    </button>
                  </div>
                ) : null}

                <button slot='reference'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    id='Outline'
                    viewBox='0 0 24 24'
                    width='20'
                    height='20'
                  >
                    <circle cx='12' cy='2' r='2' />
                    <circle cx='12' cy='12' r='2' />
                    <circle cx='12' cy='22' r='2' />
                  </svg>
                </button>
              </ve-popper>
            );
          },
        },
      ],

      employeeContracts: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'center',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'EmploymentType',
          key: 'type',
          title: 'Type',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'JobTitle',
          key: 'jobTitle',
          title: 'Job Title',
          headerAlign: 'left',
          align: 'left',
        },
        {
          field: 'StartDate',
          key: 'startDate',
          title: 'Start Date',
          headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format('DD/MM/YYYY'),
        },
        {
          field: 'EndDate',
          key: 'endDate',
          title: 'End Date',
          headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ row }) =>
            row.EndDate &&
            moment(row.EndDate).format('DD/MM/YYYY') != '01/01/0001'
              ? moment(row.EndDate).format('DD/MM/YYYY')
              : 'N/A',
        },
        {
          field: 'EmploymentStatus',
          key: 'status',
          title: 'Status',
          headerAlign: 'left',
          align: 'left',
        },
        {
          title: 'Action',
          field: '',
          key: 'action',
          renderBodyCell: ({ row }) => {
            // Your existing code for the "Action" column goes here
            return (
              <ve-popper
                trigger='clickToOpen'
                options={{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }}
              >
                {this.getUserRole.toLowerCase() === 'hrmanager' ? (
                  <div class='bg-white p-2 shadow-md popper'>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='border-radius: 0 !important'
                      onClick={() => this.handleEditContractButtonClick(row)}
                    >
                      Edit
                    </button>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='border-radius: 0 !important'
                      onClick={() => this.handleContractDeleteButtonClick(row)}
                    >
                      Delete
                    </button>
                  </div>
                ) : null}

                <button slot='reference'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    id='Outline'
                    viewBox='0 0 24 24'
                    width='20'
                    height='20'
                  >
                    <circle cx='12' cy='2' r='2' />
                    <circle cx='12' cy='12' r='2' />
                    <circle cx='12' cy='22' r='2' />
                  </svg>
                </button>
              </ve-popper>
            );
          },
        },
      ],

      tableData: [],
    };
  },

  computed: {
    ...mapGetters([
      'getToken',
      'getTabTitle',
      'getOrganization',
      'getCurrentEmployeeId',
      'getUser',
      'getUserRole',
      'getIsLoading',
    ]),

    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  methods: {
    showBulkUploadCallback() {
      this.showBulkUpload = false;
      // this.getContracts();
    },
    close() {
      this.showBulkUpload = false;
    },
    formatDate(dateString) {
      const format = 'DD/MM/YYYY';

      // Check if the dateString is already a Date object
      if (dateString instanceof Date) {
        return moment(dateString).format(format);
      }

      // If the date comes in as a string, parse it using the specified format
      const dateObject = moment(dateString, format).toDate();

      return moment(dateObject).format(format);
    },
    handleClick(title) {
      //console.log(title, this.index);
      this.$store.commit('setTabTitle', title);

      switch (parseInt(this.index)) {
        case 0:
          return this.showEditEmployee();

        case 1:
          return this.editJobInformation();
        default:
          break;
      }
      // return this.showEditEmployee()
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    handleAddDepartment(title) {
      this.$store.commit('setTabTitle', title);
      this.addEmployeeDepartment();
    },

    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateleaveType = false;
      this.showEditleaveType = false;
      this.showEditEmployeeDepartment = false;
      this.showAddContract = false;
      this.showEditContract = false;
    },

    handleCloseOnSuccess() {
      this.showCreateleaveType = false;
      this.showLocCrSuccess = false;
      this.showEditleaveType = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getEmpDepartments();
    },

    reloadLocal() {
      this.getDepartments();
      this.getEmpDepartments();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteDepartment(this.departmentToDelete);
    },

    handleEditButtonClick(department) {
      // alert(JSON.stringify(department));

      this.departmentToEdit = {
        ...department,
      };
      this.showEditEmployeeDepartment = true;
    },

    handleEditContractButtonClick(contract) {
      this.contractToEdit = {
        ...contract,
        StartDate: moment(contract.StartDate).format('YYYY-MM-DD'),
        EndDate: moment(contract.EndDate).format('YYYY-MM-DD'),
      };
      this.showEditContract = true;
    },
    confirmDelete(isDeleteConfirmed) {
      this.showDeletePrompt = false;

      if (isDeleteConfirmed) {
        switch (this.itemToDelete) {
          case 'department':
            this.deleteDepartment(this.departmentToDelete);
            break;
          case 'contract':
            this.deleteContract(this.contractTodDelete);
            break;

          default:
            break;
        }
      }
    },

    handleDeleteButtonClick(department) {
      this.itemToDelete = 'department';
      this.departmentToDelete = department;
      this.itemToDeleteName = department.Department;
      this.showDeletePrompt = true;
    },

    handleContractDeleteButtonClick(contract) {
      this.itemToDelete = 'contract';
      this.contractTodDelete = contract;
      this.itemToDeleteName = contract.JobTitle;
      this.showDeletePrompt = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getEmpDepartments();
    },

    getEmpDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/job/information/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              // //console.log(response.data.Data)
              this.tableData = response.data.Data.employeeDepartments;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/employee/department/{employeeDepartmentId}/v1/delete
    deleteDepartment(row) {
      console.log(row);
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },

        data: {
          ...row,
          EmployeeDepartmentId: row.employeeDepartmentId,
        },
      };

      axios
        .delete(
          `${this.getOrganization}/employee/department/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify.success({
                title: 'Success',
                message: response.data.StatusMessage,
              });

              this.reload();
              this.currentTableData.filter(
                (e) => e.employeeDepartmentId !== row.employeeDepartmentId
              );
              this.filteredTableData.filter(
                (e) => e.employeeDepartmentId !== row.employeeDepartmentId
              );
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            this.$notify.error({ title: 'Failure', message: error.message });
          }
        );
    },
    // /{organization}/employee/contract/v1/delete
    deleteContract(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          data: {
            EmpContractId: row.EmpContractId,
          },
        },
      };
      axios
        .delete(
          `${this.getOrganization}/employee/contract/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify.success({
                title: 'Success',
                message: response.data.StatusMessage,
              });

              this.reload();
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.success({ title: 'Success', message: error.message });
          }
        );
    },
    exportTemplate() {
      importTemplateGenerator(
        this.columns.filter(
          (c) =>
            c.field !== 'Role' &&
            c.field !== 'EmployementType' &&
            c.field !== 'EmploymentStatus' &&
            c.field !== 'JobGrade'
        ),

        'Employees',
        [
          {
            name: 'EmployeeDepartments',
            headers: [
              'EmployeeNo',
              'Company',
              'Branch',
              'Department',
              'JobTitle',
            ],
            data: [
              ['EMPLOYEE-01', 'DataposIT', 'HQ', 'Business Apps', 'PMO'],
              ['EMPLOYEE-02', 'Ace', 'HQ', 'Infrastructure', 'Web Developer'],
            ],
          },
          {
            name: 'EmployeeContracts',
            headers: ['EmployeeNo', 'EmploymentType', 'StartDate', 'EndDate'],
            data: [
              [
                'EMPLOYEE-01',
                'Contract',
                moment(moment(new Date()).format('DD/MM/YYYY')).format(
                  'DD/MM/YYYY'
                ),
                moment(new Date()).format('DD/MM/YYYY'),
              ],
              [
                'EMPLOYEE-02',
                'Permanent',
                moment(new Date()).format('DD/MM/YYYY'),
                moment(new Date()).format('DD/MM/YYYY'),
              ],
            ],
          },
          // Add more dimensions as needed
        ],
        false,
        true
      );
    },
  },

  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;

    if (this.getTabTitle) {
      this.tabTitle = this.getTabTitle.trim();
    }
    this.getEmpDepartments();
    this.setPageSizes();
    //console.log(this.getUserRole)
  },
  mounted() {
    if (this.tabTitle && this.tabTitle.trim() === 'Employee Departments') {
      this.tableData = this.empDepartmentsData;
    }
  },
};
</script>
